"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FaqSectionItemContext = exports.FaqContainer = void 0;
exports.default = FaqSection;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _headlineLockup = _interopRequireDefault(require("../../../elements/other/headline-lockup"));
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _faqItem = _interopRequireDefault(require("./faq-item"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// eslint-disable-next-line no-unused-vars

const FaqContainer = exports.FaqContainer = /*#__PURE__*/(0, _react2.styled)(_section.default)({
  name: "FaqContainer",
  class: "pl-fq93wpy"
});
const FaqList = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "FaqList",
  class: "pl-f8v5nqw"
});

/**
 * FaqSection component.
 * @module FaqSection
 *
 * @param {Object} props React props
 * @param {string} props._name tracking name for the component
 * @param {string} props.heading heading text
 * @param {string} props.description description text
 * @param {array} props.faqs Array of child FaqItems. If empty the entire FaqSection will not show.
 * @param {boolean} props.expandAnswers show all Faq Items as expanded
 * @param {string} props.verticalMargin Vertical Layout Spacing Values
 * @param {number} [props.headlineLineLength=2] Controls the max-width of the headline in em units.
 *   Recommended: 1.2-2.0. Default: 2. Increase for longer headlines to reduce wrapping.
 * @returns {React.ReactElement} FaqSection component
 * @public
 */
function FaqSection({
  _name,
  heading,
  description,
  faqs,
  expandAnswers: defaultValue = false,
  onValueChange = () => {},
  verticalMargin,
  headlineLineLength = 2 // Default value for longer headlines per dev notes
}) {
  return /*#__PURE__*/_react.default.createElement(FaqContainer, {
    _name: _name,
    verticalMargin: verticalMargin,
    padding: "none",
    textAlign: "center",
    dataCy: "faq-section"
  }, /*#__PURE__*/_react.default.createElement(_headlineLockup.default, {
    headlineTag: "h2",
    heading: heading,
    description: description,
    textAlign: "center",
    headlineLineLength: headlineLineLength
  }), /*#__PURE__*/_react.default.createElement(FaqList, {
    itemScope: true,
    itemType: "https://schema.org/FAQPage"
  }, /*#__PURE__*/_react.default.createElement(FaqSectionItemContext.Provider, {
    value: {
      defaultValue,
      onValueChange
    }
  }, faqs)));
}
const FaqSectionItemContext = exports.FaqSectionItemContext = /*#__PURE__*/(0, _react.createContext)({
  defaultValue: false,
  onValueChange: () => {}
});
FaqSection.propTypes = {
  _name: _propTypes.default.string,
  heading: _propTypes.default.string,
  description: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  faqs: _propTypes.default.node,
  expandAnswers: _propTypes.default.bool,
  onValueChange: _propTypes.default.func,
  headlineLineLength: _propTypes.default.number,
  // Controls the max-width of the headline in em units. Recommended: 1.2-2.0.
  ..._patternLibraryUtils.marginProps
};